import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=06775a3d&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=06775a3d&prod&lang=less&scoped=true"
import style1 from "./upload.vue?vue&type=style&index=1&id=06775a3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06775a3d",
  null
  
)

export default component.exports